var moment = require("moment-timezone");
import { commonConstant } from "../../../../server/triage/constants";
import { generateJsonWebToken, checkAndGetSessionStorageValue, translateContent, getAndSetTranslateVal,checkAndChangeContent, checkAndGetLocalStorageValue } from "../../../../features/utils";

export async function accessListDetails({ state, actions }) {
  //Get current browser time
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const currentTime = moment().tz(timezone).format("YYYY-MM-DD H:mm");
  var tempState = "";
  var province = checkAndGetLocalStorageValue("statename");
  var country = checkAndGetLocalStorageValue("countryname");
  if (province === "Quebec") {
    tempState = "Québec";
  } else {
    tempState = province;
  }

  var translateArray = [
      {
          text: tempState,
      },
      {
          text: country,
      },
  ];
  var translatedContent = await translateContent(translateArray, "en");
  var listOfTranslatedArr = translatedContent.response.results;

  tempState = await getAndSetTranslateVal(listOfTranslatedArr, 0, tempState);
  var jwtAccess_Token = generateJsonWebToken()
  var access_Token = checkAndGetSessionStorageValue("accessToken")
  var tempCountry = await getAndSetTranslateVal(listOfTranslatedArr, 1, country);
  
  tempCountry = checkAndChangeContent(tempCountry, commonConstant.USA);
   
  const data = {
      TargetCountry: tempCountry,
      TargetStateProvince: tempState,
      ServiceTypes: ["Telemedicine"],
      DesiredAccessTime: currentTime,
      jwtAccessToken : jwtAccess_Token,
      accessToken : access_Token,
      ExcludedServiceAccessPointIds:
          state.triageRequest.excludedServiceAccessPointId,
  };

  var responseData = await actions.sendTriageRequest({
    action: "getAccessDetails",
    data
    });
    if (responseData && responseData.message === commonConstant.success ) {
      if(responseData.data !== ""){
      actions.setTriageResponse({
        vendorsList: responseData.data.results,
      });
    }
     await actions.generateRecommendedCareOptions();
     return state.triageResponse.recommendedCareOptions;
    }
}
